import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { Tabs, Tab, withStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import WarningIcon from "@material-ui/icons/Warning";
var PANELS = ["Maternal", "Paternal", "Family Member"];
var TabPanel = React.memo(function (_a) {
  var children = _a.children,
    value = _a.value,
    index = _a.index,
    other = __rest(_a, ["children", "value", "index"]);
  return React.createElement("div", Object.assign({
    role: "tabpanel",
    hidden: value !== index,
    id: "tabpanel-".concat(index),
    "aria-labelledby": "tab-".concat(index)
  }, other), value === index && React.createElement(Box, {
    p: 3
  }, children));
});
function a11yProps(index) {
  return {
    id: "tab-".concat(index),
    "aria-controls": "tabpanel-".concat(index)
  };
}
// Custom styles for the Tabs and Tab components
var styles = function styles(theme) {
  return {
    tabsRoot: {
      opacity: 0.7,
      backgroundColor: "#8B7769" // Background color for the tabs container
    },
    flexContainer: {
      display: "flex",
      justifyContent: "space-around" // Add custom CSS for flex container
    },
    tabRoot: {
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#A08A7A" // Hover background color
      }
    },
    tabSelected: {
      backgroundColor: "#6B5D53" // Background color for the selected tab
    }
  };
};
function TabBarV2(_ref) {
  var renderPanel = _ref.renderPanel,
    tabError = _ref.tabError,
    classes = _ref.classes;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var handleChange = React.useCallback(function (event, newValue) {
    setValue(newValue);
  }, []);
  // Check if a specific tab has errors
  var hasError = function hasError(panel) {
    return tabError.includes(panel.toLowerCase());
  };
  return React.createElement(Box, {
    sx: {
      width: "100%"
    }
  }, React.createElement(Box, {
    sx: {
      borderBottom: 1,
      borderColor: "divider"
    }
  }, React.createElement(Tabs, {
    value: value,
    onChange: handleChange,
    "aria-label": "profile tab bar",
    classes: {
      root: classes.tabsRoot,
      flexContainer: classes.flexContainer // Apply custom CSS for flex container
    }
  }, PANELS.map(function (panel, index) {
    return React.createElement(Tab, Object.assign({
      key: panel,
      label: React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, panel, hasError(panel) && React.createElement(WarningIcon, {
        fontSize: "small",
        color: "error",
        style: {
          marginLeft: "8px"
        }
      })),
      classes: {
        root: classes.tabRoot,
        selected: classes.tabSelected // Apply custom styles for the selected tab
      }
    }, a11yProps(index)));
  }))), PANELS.map(function (panel, index) {
    return React.createElement(TabPanel, {
      key: panel,
      value: value,
      index: index
    }, renderPanel(panel));
  }));
}
// Wrap the component with `withStyles` to apply the custom styles
export default withStyles(styles)(TabBarV2);